// 開機讀取疊層（index.html 的 #loading-overlay）與遊戲啟動流程之間的橋接。
// index.html 的控制腳本只讀 window.__GAME_LOADING 狀態，與遊戲模組完全解耦；
// 啟動流程（main.ts）透過此處函式回報進度與就緒，不直接碰 DOM。

/** 開機讀取疊層的共享狀態（index.html 控制腳本與遊戲啟動流程的單一事實來源）。 */
export interface GameLoadingState {
  /** 載入進度 0..1（單調遞增；實際顯示由疊層做時間估計平滑與封頂）。 */
  progress: number
  /** 主畫面組裝完成、可補滿進度並淡出疊層。 */
  ready: boolean
}

declare global {
  interface Window {
    __GAME_LOADING?: GameLoadingState
  }
}

// 疊層腳本會在 index.html 先建立此物件；此處容錯建立，避免載入順序相依。
function loadingState(): GameLoadingState {
  const existing = window.__GAME_LOADING
  if (existing !== undefined) {
    return existing
  }
  const created: GameLoadingState = { progress: 0, ready: false }
  window.__GAME_LOADING = created
  return created
}

/** 回報載入進度（0..1）。低於目前值會被忽略以維持單調遞增。 */
export function setLoadingProgress(progress: number): void {
  const clamped = Math.max(0, Math.min(1, progress))
  const state = loadingState()
  if (clamped > state.progress) {
    state.progress = clamped
  }
}

/** 標記主畫面就緒，請疊層補滿進度並淡出。 */
export function markGameReady(): void {
  const state = loadingState()
  state.progress = 1
  state.ready = true
}
